import React, {memo, ReactNode} from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import CustomCssTransition from "@/app/components/custom_css_transition/widget";
import {ButtonText} from "@/app/components/texts";

interface ButtonProps {
  text?: string,
  icon?: ReactNode
  onClick: () => void
  isDisabled?: boolean
  isViolet?: boolean
  isRed?: boolean
  isRedText?: boolean
  isGreen?: boolean
  isLoading?: boolean
  isTransparent?: boolean
  alignLeft?: boolean
  smallRadius?: boolean
  isOutline?: boolean
  isText?: boolean
  isBlackLoading?: boolean
  notExpanded?: boolean
  circle?: boolean
  isWhite?: boolean
  className?: string
}

const Button: React.FC<ButtonProps> = ({
                                         text,
                                         icon,
                                         isDisabled = false,
                                         isViolet = false,
                                         isRed = false,
                                         isRedText = false,
                                         isGreen = false,
                                         isLoading = false,
                                         isTransparent = false,
                                         alignLeft = false,
                                         isOutline = false,
                                         isText = false,
                                         isBlackLoading = false,
                                         notExpanded = false,
                                         circle = false,
                                         isWhite = false,
                                         onClick,
                                         className
                                       }) => {
  return (
    <div
      className={classNames(styles.button,
        {[styles.violet]: isViolet},
        {[styles.isRedText]: isRedText},
        {[styles.disabled]: isDisabled},
        {[styles.green]: isGreen},
        {[styles.outline]: isOutline},
        {[styles.red]: isRed},
        {[styles.transparent]: isTransparent},
        {[styles.alignLeft]: alignLeft},
        {[styles.smallRadius]: alignLeft},
        {[styles.isText]: isText},
        {[styles.notExpanded]: notExpanded},
        {[styles.white]: isWhite},
        {[styles.circle]: circle},
        className
      )}
      onClick={isDisabled ? () => {
      } : onClick}>
      <CustomCssTransition bool={isLoading}>
        {isLoading ? <CircularProgressIndicator isGreen={isBlackLoading}/> : (
          <div className={classNames(styles.content, {[styles.hidden]: isLoading})}>
            {icon}
            {text && <ButtonText text={text} className={styles.text}/>}
          </div>)}
      </CustomCssTransition>
    </div>
  );
};

export default memo(Button);